import { cn } from '@/lib/core/utils/cn';
import { Icon } from '@/components/ui/icon';

export interface CategoryCardProps {
  name: string;
  icon?: string;
  isActive: boolean;
  isLoading?: boolean;
  onClick: () => void;
}

export function CategoryCard({ name, icon, isActive, isLoading, onClick }: CategoryCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative flex h-27 w-full cursor-pointer flex-col items-start justify-between rounded-[2px] px-6 py-4 text-left transition-colors',
        isActive ? 'bg-[#1a1a1a]' : 'bg-[#f4f4f4] hover:bg-[#1a1a1a]'
      )}
      aria-pressed={isActive}
      disabled={isLoading}
    >
      {icon && (
        <Icon
          name={icon}
          width={32}
          height={32}
          strokeWidth={1.5}
          className={cn('shrink-0', isActive ? 'text-white' : 'text-[#1a1a1a] group-hover:text-white')}
        />
      )}
      <span
        className={cn(
          'font-inter text-[16px] font-medium tracking-[0.25px]',
          isActive ? 'text-white' : 'text-[#1a1a1a] group-hover:text-white'
        )}
      >
        {name}
      </span>
    </button>
  );
}
